import { KitIcon, KitIconProps } from 'components'
import { ScaleProps, useScaleProps } from '../../utils/scaleUtils'

export type Props = ScaleProps<KitIconProps>

export default function SKitIcon(props: Props) {
  const { styleProps, rest } = useScaleProps(props)
  const { fontSize, ...restStyleProps } = styleProps
  return <KitIcon size={fontSize} {...restStyleProps} {...rest} />
}
